<div class="wl-tab-container" [hidden]="!selected" *ngIf="!isTabWellContent && loadContent && tabContentTemplate">
  <ng-container *ngTemplateOutlet="tabContentTemplate"></ng-container>
</div>
<ng-template #projectedContent><ng-content></ng-content></ng-template>
